<template>
  <div>
    <div
      style="display: none"
    />
    <DialogDefault
      :open.sync="myValue"
      title="Erro no envio"
      width="370px"
      @close="close"
    >
      <template v-slot:title>
        <div/>
      </template>
      <div>
        <div
          class="cancelamento-solicitacao-header"
        >
          <inline-svg fill="#CCCCCC" height="100" :src="require('@/assets/img/img_helper_receipt.svg')"/>
        </div>
        <div style="margin-bottom: 50px">
          <div class="cancela-solicitacao-titulo">
            Solicitação Cancelada
          </div>
          <div>
            <div class="cancela-solicitacao-texto">
              Solicitação cancelada com sucesso
            </div>
          </div>
        </div>
        <ButtonDefault
          title="CONCLUÍDO"
          @click="close"
        />
      </div>
    </DialogDefault>
  </div>
</template>
<script>
import ButtonDefault from '@/components/buttons/ButtonDefault'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import { mapActions } from 'vuex'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'DialogCancelamentoSolicitacao',
  components: { ButtonDefault, DialogDefault, InlineSvg },
  ...mapActions('TempleteSolicitacaoStore', ['clean']),
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      myValue: false
    }
  },
  watch: {
    value (newValue) {
      this.myValue = newValue
    },
    myValue (newValue) {
      if (!newValue) {
        this.$emit('input', false)
      }
    }
  },
  methods: {
    init () {
      if (this.$route.query.novo) {
        this.myValue = true
      }
      this.clean()
    },
    close () {
      this.myValue = false
      this.$emit('click')
    }
  },
  mounted () {
    this.init()
  }
}
</script>
